import { render, staticRenderFns } from "./textShadowColorController.vue?vue&type=template&id=473ceb59&"
import script from "./textShadowColorController.vue?vue&type=script&lang=ts&"
export * from "./textShadowColorController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports